import React, { FC } from 'react';
import styles from './WixelIcon.scss';

export const WixelIcon: FC = () => <div className={styles.wixelIcon} />;
